<template>
    <div class="review_icon" v-if="item.is_top == 1 || item.is_wonderful == 1" >{{item.is_top == 1 ? '置顶' : item.is_wonderful == 1 ? '精彩' : ''}}</div>
</template>
<script>
export default {
    props:['comment'],
    data:function(){
        return {
            item:this.comment
        }
    }
}
</script>
<style lang="stylus">
    .review_icon
        font-size:0.6rem
        padding:0rem 0.2rem
        color:#ffba00
        display:inline-block
        border:1px solid #ffba00
        border-radius:0.1rem
        margin-right: 0.2rem
</style>




// WEBPACK FOOTER //
// topWonder.vue?6927562e